<template>
    <div class="py-4 px-4 lg:px-8 mx-0 my-3 lg:mx-6">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="text-center">{{ model.name }}</h1>
                    <p class="text-center">
                        We are always looking for talented people to join our
                        team. If you are interested in joining our team, please
                        send your resume to
                        <a href="mailto:admin@gmail.com">our email</a>
                    </p>
                    <p v-html="model.description"></p>
                </div>
            </div>
            <div class="card">
                <TabView v-model:activeIndex="active">
                    <TabPanel header="Informasi Pribadi" :disabled="active > 0">
                        <PersonalDataVue ref="personal" :submitted="submitted"></PersonalDataVue>
                        <Button label="Selanjutnya" class="p-button p-component p-button-primary" @click="onApply" />
                    </TabPanel>
                    <TabPanel header="Rekening Bank" :disabled="active < 1">
                        <PersonalBankAccount ref="bankAccount" :applicant="applicant"></PersonalBankAccount>
                        <Button label="Selanjutnya" class="p-button p-component p-button-primary" @click="storeBank" />
                    </TabPanel>
                    <TabPanel header="Pendidikan" :disabled="active < 2">
                        <Education ref="education" :applicant="applicant"></Education>
                        <Button label="Selanjutnya" class="p-button p-component p-button-primary" @click="storeEducations" />
                    </TabPanel>
                    <TabPanel header="Pengalaman Kerja" :disabled="active < 3">
                        <WorkExperience ref="experience" :applicant="applicant"></WorkExperience>
                        <Button label="Selanjutnya" class="p-button p-component p-button-primary"
                            @click="storeWorkExperience" />
                    </TabPanel>
                    <TabPanel header="Sertifikasi" :disabled="active < 4">
                        <Certification ref="certification" :applicant="applicant"></Certification>
                        <Button label="Kirimkan" class="p-button p-component p-button-primary" @click="storeCertificates" />
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>
<script>
import { Link, usePage } from "@inertiajs/inertia-vue3";
import axios from "axios";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Layout from "../../Layouts/LandingLayout";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import PersonalDataVue from "./Components/PersonalData.vue";
import Education from "./Components/Education.vue";
import WorkExperience from "./Components/WorkExperience.vue";
import Certification from "./Components/Certification.vue";
import PersonalBankAccount from "./Components/PersonalBankAccount.vue";
import FlashMessage from "../../Services/FlashMessage";

export default {
    layout: Layout,
    components: {
        Link,
        Button,
        Divider,
        TabView,
        TabPanel,
        PersonalDataVue,
        Education,
        WorkExperience,
        Certification,
        PersonalBankAccount,
    },
    mixins: [FlashMessage],
    data() {
        return {
            model: {},
            submitted: false,
            active: 0,
            validated: false,
            applicant: {},
            errors: [],
        };
    },
    mounted() {
        this.model = usePage().props.value.vacancy_detail;
    },
    methods: {
        storeBank(){
            let bankAccount = this.$refs.bankAccount.form;
            this.submitted = true;

            axios.post(`${this.$page.props.appUrl}careers/banks`, {...bankAccount, applicant_id: this.applicant.id})
            .then((data) => {
                this.flashSuccess("Informasi Rekening Bank Ditambahkan");
                this.active = 2;
            })
            .catch((error) => {
                this.flashError("Error Saat Menambahkan Informasi Rekening");
            })
        },
        storeEducations() {
            let educations = this.$refs.education.models;
            if (Object.keys(educations).length <= 0) {
                this.flashError("Pendidikan Harus Diisi");
            } else {
                let payload = {...educations};

                axios.post(`${this.$page.props.appUrl}careers/educations`,payload)
                .then((data) => {
                    this.flashSuccess("Data Pendidikan Pelamar Diupdate");
                    this.active = 3;
                })
                .catch((error) => {
                    this.flashError("Error Saat Update Data Pendidikan Pelamar")
                })
            }
        },
        storeWorkExperience() {
            let experiences = this.$refs.experience.models;
            if (Object.keys(experiences).length <= 0) {
                this.flashError("Pengalaman kerja harus diisi")
            } else {
                let payload = {...experiences};
                axios.post(`${this.$page.props.appUrl}careers/experiences`,payload)
                .then((data) => {
                    this.flashSuccess("Pengalaman kerja pelamar berhasil di update")
                    this.active = 4;
                })
                .catch((error) => {
                    this.flashError("Error saat update pengalaman kerja pelamar");
                })
            }
        },
        storeCertificates() {
            let certificates = this.$refs.certification.models;
            if (Object.keys(certificates).length >= 0) {
                let payload = {...certificates};
                axios.post(`${this.$page.props.appUrl}careers/certificates`,payload)
                .then((data) => {
                    this.flashSuccess("Data Pelatihan Pelamar Berhasi di update");
                    window.location.reload();
                })
                .catch((error) => {
                    this.flashError("Error saat update data pelatihan pelamar");
                })
            }
        },
        onApply() {
            let personalInfo = this.$refs.personal.form;

            this.submitted = true;

            let formData = new FormData();
            formData.append("vacancies_id", this.model.id);
            formData.append("id_card_number", personalInfo.id_card_number);
            formData.append("name", personalInfo.name);
            formData.append("gender", personalInfo.gender);
            formData.append("birthplace", personalInfo.birthplace);
            formData.append("birthdate", personalInfo.birthdate);
            formData.append("email", personalInfo.email);
            formData.append("phone_number", personalInfo.phone_number);
            formData.append("address", personalInfo.address);
            formData.append("address_2", personalInfo.address_2);
            formData.append(
                "last_formal_education",
                personalInfo.last_education_level
            );
            formData.append("resume", personalInfo.resume);
            formData.append("photo", personalInfo.photo);

            axios
                .post(this.route("careers.store"), formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.submitted = false;
                    this.flashSuccess("Lamaran anda telah dikirimkan")

                    this.applicant = response.data.data.data;
                    this.active = 1;
                })
                .catch((error) => {
                    const errors = error.response.data.errors;
                    const newArray = [];

                    for(const key in errors){
                        const valueArray = errors[key];

                        const keyValueObject = {};
                        keyValueObject[key] = valueArray;

                        newArray.push(keyValueObject);
                    }

                    this.errors = newArray;
                    this.flashError("Harap Isi Semua Field yang diwajibkan !")
                });
        },
    },
};
</script>
